export default __webpack_public_path__ + "static/media/fig-04-orientation-chainages.6822bd6e.png";